import { IconButton } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const IconButtonAsLinkExample = {
  title: "IconButton - As link",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [],

  Preview() {
    return (
      <IconButton
        variant="primary"
        aria-label="Название кнопки"
        asChild
        size="medium"
      >
        <a
          href="/"
          rel="noreferrer"
          target="_blank"
        >
          <PlaceholderIcon />
        </a>
      </IconButton>
    )
  },

  getCode() {
    return `<IconButton
  variant="primary"
  aria-label="Название кнопки"
  asChild
  size="medium"
>
  <a
    href="/"
    rel="noreferrer"
    target="_blank"
  >
    <Icon24Placeholder />
  </a>
</IconButton>`
  },
}